<template>
  <Draggable
    handle=".handle"
    @end="handleMoveNest"
    @start="setForceFallBack"
    @sort="sort"
    :list="list"
    :scroll-sensitivity="200"
    :scrollSpeed="20"
    :force-fallback="force"
    group="question"
    item-key="random_id"
  >
    <template #item="{ element, index }">
      <div
        class="mt-5 type-wrapper drag-item"
        :class="{
          'is-hide': element.is_display === $defines.Part_Is_Display_No,
        }"
      >
        <component
          :element="element"
          :sortMode="sortMode"
          :qIndex="index + 1"
          :is="'Edit' + ItemTypesMap[element.type]"
          :index="index + 1"
          @newList="$emit('newList', $event)"
          @deleteItem="deleteItem"
          @copyItem="copyItem"
        />
      </div>
    </template>
  </Draggable>
</template>
<script>
import EditInput from '@/components/EditInput.vue'
import EditFile from '@/components/EditFile.vue'
import EditNumberInput from '@/components/EditNumberInput.vue'
import EditRadio from '@/components/EditRadio.vue'
import EditNest from '@/components/EditNest.vue'
import EditForm from '@/components/EditForm.vue'
import EditRangeBar from '@/components/EditRangeBar.vue'
import EditTextarea from '@/components/EditTextarea.vue'
import EditCheckBox from '@/components/EditCheckBox.vue'
import EditCategoryTitle from '@/components/EditCategoryTitle.vue'
import EditDivider from '@/components/EditDivider.vue'
import EditStar from '@/components/EditStar.vue'
import EditItemSort from '@/components/EditItemSort.vue'
import EditDate from '@/components/EditDate.vue'
import EditDynamicForm from '@/components/EditDynamicForm.vue'
import Draggable from 'vuedraggable'
import _ from 'lodash'
import { ItemTypesMap } from '@/defines'
import {  ref, watch } from 'vue'
import { useMouse } from '@vueuse/core'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    sortMode: {
      type: Boolean,
      default: false,
    },
    questionnaireWrapper: {
      type: Object,
      default: ()=>{}
    }
  },
  emits: ['newList', 'cloneList', 'deleteItem', 'copyItem'],
  setup(props, { emit }) {
    // const displayIndexMap = computed(() =>
    //   props.list
    //     .filter((item) => item.type !== '4' && item.type !== '14')
    //     .reduce((accu, cur, i) => {
    //       accu[cur.id] = i + 1
    //       return accu
    //     }, {}),
    // )
    const force = ref(false)
    const setForceFallBack = () => {
      force.value = true
    }
    const { x, y } = useMouse({ type: 'client', touch: true })
    watch(
      ()=>y.value,
      ()=>{
        const scrollActive = 100
        const pageOffset = window.pageYOffset
        if(force.value){
          console.log(force.value);
          if(window.innerHeight - y.value <= scrollActive){
            window.scrollTo(0, pageOffset + 500)
          }else if(y.value < 150){
            window.scrollTo(0, pageOffset - 500)
          }
        }
      }
    )

    const handleMoveNest = async (e) => {
      force.value = false
      const clone = _.cloneDeep(props.list)
      const moveTarget = clone[e.newIndex]
      if (moveTarget.name === 'Nest') {
        const nestChild = clone.filter((item) => {
          return item.name === 'NestChild' && item.nest === moveTarget.id
        })
        const ary = clone.filter((item) => {
          return item.nest !== moveTarget.id
        })
        ary.splice(e.newIndex + 1, 0, ...nestChild)
        emit('cloneList', ary)
      }
      if (moveTarget.name === 'Form') {
        const formChild = clone.filter((item) => {
          return item.name === 'FormChild' && item.nest === moveTarget.id
        })
        const ary = clone.filter((item) => {
          return item.nest !== moveTarget.id
        })
        ary.splice(e.newIndex + 1, 0, ...formChild)
        emit('cloneList', ary)
      }
    }
    const deleteItem = (target) => {
      document.querySelector('.popover')?.remove()
      const ary = props.list.filter((item) => {
        return item.part_item_id !== target.part_item_id
      })
      emit('deleteItem', [ary, target])
    }

    const copyItem = (target) => {
      emit('copyItem', target)
    }

    return {
      handleMoveNest,
      deleteItem,
      copyItem,
      ItemTypesMap,
      setForceFallBack,
      force,
      x,
      y,
    }
  },
  components: {
    EditInput,
    EditRadio,
    EditNest,
    EditRangeBar,
    EditTextarea,
    EditCheckBox,
    EditNumberInput,
    EditFile,
    EditCategoryTitle,
    EditStar,
    EditDivider,
    EditDate,
    Draggable,
    EditItemSort,
    EditForm,
    EditDynamicForm,
  },
}
</script>

<style lang="scss" scoped>
.mh {
  min-height: 200px;
}
.type-wrapper {
  background: #ffffff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding-top: 8px;
}
.isMove {
  height: 85px;
  overflow-y: hidden;
}
.is-hide {
  filter: brightness(80%);
}
</style>
